import React, { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  de: {
    nav: { home: 'Start', services: 'Leistungen', method: 'ROAD-Framework', blog: 'Insights', contact: 'Gespräch anfragen' },
    hero: {
      badge: 'KI-Beratung für stationären Handel, Filialisten & Franchise-Systeme',
      title: 'KI im stationären Handel, die wirklich funktioniert.',
      sub: 'ENBET steht für Entertain Better. Denn genau darum geht es im stationären Handel: um echte Interaktion, zwischen Menschen, um Erlebnisse, die kein Online-Shop liefern kann. Wir helfen Retail-Unternehmen, KI so einzusetzen, dass eure Teams mehr Zeit für das haben, was zählt – den Kunden.',
      text: '',
      cta1: 'Kostenlose Potenzialanalyse buchen',
      cta2: 'Leistungen ansehen',
    },
    intro: {
      title: 'KI im Retail braucht mehr als gute Tools.',
      paragraphs: [
        'Konzepte gibt es genug. Strategie-PowerPoints auch. Was fehlt, ist jemand, der dafür sorgt, dass KI nicht auf dem Bildschirm, sondern im Tagesgeschäft ankommt – an der Kasse, im Lager, im Kundengespräch.',
        'ENBET (Entertain Better) Consulting liefert keine Folien. Wir entwickeln Roadmaps, die mit eurem Team funktionieren. Der Name ist Programm: Es geht um besseres Entertain – nicht durch mehr Folien, sondern durch mehr Zeit für das, was Menschen im stationären Handel zwischenmenschlich einzigartig macht.',
        'Mit dem ROAD-Framework analysieren wir, wo eure Teams heute entlastet werden können, wo Kundenkontakt aktuell leidet – und wo eure Mitarbeiter morgen produktiver arbeiten, ohne dass die Menschlichkeit verloren geht.',
      ],
    },
    why: {
      title: 'Keine KI-Beratung von der Stange.',
      paragraphs: [
        'ENBET (Entertain Better) verbindet tiefes Verständnis für stationären Betrieb mit konkretem KI-Know-how. Das macht den Unterschied zur klassischen Beratung.',
        'Retail-Expertise — Kein generisches KI-Wissen, das auf jeden passt. Echtes Verständnis für stationäre Abläufe, Filialstrukturen und die Realität an der Front – wo Entscheidungen über Kundenzufriedenheit und Umsätze täglich fallen.',
        'Klare Priorisierung — Wir sagen auch, was keinen Sinn macht. Ehrliche Einschätzung schützt vor Fehlinvestitionen – und bewahrt eure Ressourcen für das, was wirklich wirkt.',
        'Umsetzung zuerst — Roadmaps, Schulungen und Audits sind kein Selbstzweck. Alles ist darauf ausgerichtet, dass KI im echten Betrieb ankommt – im ROME-Prinzip: nur messbare Ergebnisse zählen.',
      ],
    },
    audience: {
      title: 'Für wen ENBET (Entertain Better) gemacht ist.',
      intro: 'Wir arbeiten mit Unternehmen, die ihre menschliche Stärke gezielt weiterentwickeln wollen – nicht mit denen, die Technologie um der Technologie willen einführen. Entertain Better heißt: Der Mensch im Zentrum. KI als Werkzeug, das den Weg freimacht.',
      bullets: [
        { title: 'Stationäre Geschäfte mit hoher Kundennähe', text: 'Wo der persönliche Kontakt der wichtigste Wettbewerbsvorteil ist.' },
        { title: 'Filialisten und serviceintensive Standorte', text: 'Wo Standardisierung und Menschlichkeit gleichzeitig funktionieren müssen.' },
        { title: 'Franchise-Systeme und Multi-Location-Konzepte', text: 'Wo Konsistenz über Standorte hinweg mit lokaler Identität vereinbar sein muss.' },
        { title: 'Retail-Unternehmen mit Frontline-Teams', text: 'Wo Mitarbeiter die erste – und oft einzige – Schnittstelle zum Kunden sind.' },
        { title: 'Unternehmen, die Kundennähe als echten Wettbewerbsvorteil verstehen', text: 'Der Online-Handel kann nicht umarmen. Der stationäre Handel kann. Darum geht es.' },
      ],
      closing: 'Wenn ihr eine klare Richtung für bessere Abläufe, stärkere Teams und mehr Servicequalität sucht – dann seid ihr hier richtig.',
    },
    road: {
      label: 'ROAD-Framework',
      title: 'Wie wir KI-Einführung im stationären Handel strukturieren',
      intro: '',
      steps: [],
    },
    services: {
      label: 'Leistungen',
      title: 'In 3 klaren Schritten zur produktiven KI.',
      subtitle: 'Drei Stationen. Vom ehrlichen Standort-Check bis zur produktiven KI im Betrieb. Jedes Modul kann einzeln gebucht werden – oder als zusammenhängender Weg.',
      cta_label: 'Gespräch vereinbaren',
      items: [
        {
          title: 'KI Ready Check',
          price_label: 'Festpreis: 850 €',
          subtitle: 'Umfassende betriebliche Bestandsaufnahme & Potenzialanalyse',
          quote: 'Garbage in, garbage out.',
          quote_sub: 'Ehrliche Daten. Klare Entscheidung. Kein Budget für KI-Experimente verbrennen.',
          kpis: [
            { value: '5+', label: 'Abteilungen analysiert' },
            { value: '100%', label: 'Datenklarheit' },
          ],
          tagline: 'Die ungefilterte Wahrheit für dein Unternehmen.',
          text: 'Der KI Ready Check ist eure fundierte, datenbasierte Diagnose – ohne Beschönigung, ohne Standard-Einheitsgröße. Künstliche Intelligenz darf kein teures Experiment sein. Sie muss messbaren wirtschaftlichen Mehrwert bringen. Bevor ihr investiert, wird geklärt, ob und wo sich das lohnt.',
          bullets: [
            { label: 'Echte Daten statt Standard-Templates', text: 'Eine individuelle, tiefgehende Analyse eures Betriebs – keine automatisierten Textbausteine.' },
            { label: 'Strukturierte Prozess-Diagnose', text: 'Glasklare Identifikation eurer operativen Reibungspunkte, Medienbrüche und täglichen Engpässe.' },
            { label: 'Quantifizierte Verlustzeiten', text: 'Wir beziffern das ungenutzte Zeitpotenzial pro Abteilung in echten Zahlen und Fakten.' },
            { label: 'Objektive Wirtschaftlichkeitsprüfung', text: 'Eine ehrliche, herstellerneutrale Einordnung, welche KI-Anwendungen für euch profitabel sind.' },
            { label: 'Maximale Investitionssicherheit', text: 'Euer Schutz vor kostspieligen Fehlentscheidungen und teuren Folgekosten.' },
          ],
          duration: 'Individuell ausgearbeitet · Ortsunabhängig & effizient via Remote-Audit',
        },
        {
          title: 'KI Strategie Workshop',
          price_label: 'Investition: 3.500 €',
          subtitle: 'Deine KI-Strategie mit Rolloutplan & Use-Case-Mapping',
          quote: 'Strategie ist keine PowerPoint.',
          quote_sub: 'Strategie ist eine Entscheidung — mit Zahlen, Verantwortlichen und Datum.',
          kpis: [
            { value: '1–2 Wo.', label: 'Ausarbeitung' },
            { value: '3 Phasen', label: 'klare Roadmap' },
          ],
          tagline: 'Von der Analyse zur umsetzbaren Roadmap.',
          text: 'Ein Report bringt nur etwas, wenn er in eine klare Praxis-Strategie übersetzt wird. Im gemeinsamen Strategie-Workshop überführen wir die Erkenntnisse aus dem Ready Check in einen Fahrplan, der mit euren Entscheidern funktioniert – nicht gegen sie.',
          bullets: [
            { label: 'Deine KI-Strategie mit Rolloutplan', text: 'Das konkrete, strategische Fundament inklusive klarem Zeitrahmen.' },
            { label: 'Interaktives Use-Case-Mapping', text: 'Gemeinsame Priorisierung nach wirtschaftlichem Hebel und Machbarkeit.' },
            { label: 'Validierte ROI-Kalkulation', text: 'Fundierte Berechnung des jährlichen Einsparpotenzials im Verhältnis zu den Einführungskosten.' },
            { label: 'Pragmatische 3-Phasen-Roadmap', text: 'Chronologischer Fahrplan für die interne Einführung und Umsetzung.' },
            { label: 'Konkrete Quick-Wins', text: 'Sofort umsetzbare Optimierungsimpulse, die ohne langwierige IT-Projekte direkt Entlastung bringen.' },
          ],
          duration: '1–2 Wochen Ausarbeitung · Interaktiver Experten-Workshop mit euren Entscheidern',
        },
        {
          title: 'KI Integration',
          price_label: 'Individuelles Angebot',
          subtitle: 'Schlüsselfertige Implementierung, Begleitung & Skalierung',
          quote: 'Die beste Strategie scheitert ohne Umsetzung.',
          quote_sub: 'Wir gehen mit dir bis ins Tagesgeschäft — nicht nur bis zur Folie.',
          kpis: [
            { value: '4–6 Wo.', label: 'erster Pilot live' },
            { value: 'Live', label: 'Kosten-Monitoring' },
          ],
          tagline: 'Vom Konzept zur produktiven Anwendung im echten Betrieb.',
          text: 'Die beste Strategie scheitert, wenn die Umsetzung hakt oder das Team die neuen Tools nicht annimmt. Wir gehen mit euch bis ins Tagesgeschäft – nicht nur bis zur Folie.',
          bullets: [
            { label: 'Agiles Pilot-Setup', text: 'Funktionale Prototypen innerhalb von 4–6 Wochen für erste messbare Ergebnisse.' },
            { label: 'Nahtlose System-Integration', text: 'Schrittweiser Rollout im laufenden Betrieb ohne Unterbrechung des Tagesgeschäfts.' },
            { label: 'Live-Kosten- & Qualitätsmonitoring', text: 'Lückenlose Überwachung zur Vermeidung explodierender API- oder Cloud-Gebühren.' },
            { label: 'Praxisnahe Teamschulungen', text: 'Zielgerichtete Qualifizierung der Mitarbeiter für maximale Akzeptanz und sicheren Umgang mit der KI.' },
            { label: 'Zukunftssichere Skalierung', text: 'Kontinuierliche Optimierung und Ausbau für langfristiges digitales Wachstum.' },
          ],
          duration: 'Projektlaufzeit ab 3 Monaten · Umfang individuell auf eure Infrastruktur abgestimmt',
        },
      ],
    },
    howWeWork: {
      title: 'So läuft die Zusammenarbeit ab.',
      paragraphs: [
        'Wir arbeiten mit wenigen Unternehmen gleichzeitig – bewusst. Nicht weil wir nicht skalieren könnten, sondern weil Qualität und Nähe keine Marketingversprechen sind.',
        'Unsere Formate sind persönlich, strukturiert und immer auf ein konkretes Ergebnis ausgerichtet. Dazu gehören persönliche Gespräche, Vor-Ort-Termine und gemeinsame Lernformate in kleinen Gruppen.',
        'Unternehmen profitieren dabei nicht nur von unserer Begleitung – sondern auch voneinander. Gute Fragen, reale Erfahrungen und ehrlicher Austausch schaffen oft mehr Fortschritt als isolierte Einzelmaßnahmen.',
        'Unser Ziel: Keine Abhängigkeiten schaffen, sondern euer Unternehmen klarer, wirksamer und selbstständiger machen.',
      ],
    },
    community: {
      title: 'Lernen endet nicht mit dem Projekt',
      paragraphs: [
        'Wir glauben an echte Verbindung. Nicht nur zwischen Unternehmen und Kunden, sondern auch zwischen Menschen, die Verantwortung tragen und besser werden wollen.',
        'Deshalb schaffen wir Räume für Austausch, Reflexion und gemeinsames Lernen. Kleine Gruppen, persönliche Begegnung und gemeinsames Weiterdenken helfen dabei, Qualität langfristig zu entwickeln.',
        'So bleibt aus einem Projekt mehr als ein Abschluss. Es entsteht ein Netzwerk aus Praxis, Vertrauen und Weiterentwicklung.',
      ],
    },
    faq: {
      label: 'Häufige Fragen',
      title: 'Antworten auf die wichtigsten Fragen.',
      subtitle: 'Was Unternehmen am häufigsten wissen wollen, bevor sie mit uns arbeiten.',
      items: [
        {
          question: 'Was kostet eine KI-Beratung bei ENBET Consulting?',
          answer: 'Modul 1 (KI Ready Check) ist Festpreis 850 €. Modul 2 (KI Strategie Workshop) ist 3.500 €. Modul 3 (KI Integration) ist projektabhängig und wird individuell kalkuliert. Der erste 20-Minuten Potenzial-Check mit Sebastian Funke ist immer kostenlos – ohne Verkaufsdruck und ohne Folgekosten.',
        },
        {
          question: 'Wo ist ENBET Consulting ansässig?',
          answer: 'ENBET Consulting (Entertain Better) ist in Schauenburg bei Kassel in Nordhessen ansässig und arbeitet mit Unternehmen in ganz Deutschland. Audits laufen remote, Workshops und Integration vor Ort oder hybrid.',
        },
        {
          question: 'Was bedeutet Entertain Better?',
          answer: 'ENBET steht für Entertain Better. Im stationären Handel ist die größte Stärke nicht Technik, sondern echte menschliche Interaktion. KI soll Mitarbeiter nicht ersetzen, sondern ihnen Zeit zurückgeben für Beratung, Nähe, Service und Erlebnis.',
        },
        {
          question: 'Wie lange dauert eine KI-Einführung im stationären Handel?',
          answer: 'Der KI Ready Check (Modul 1) ist remote in 1–2 Wochen abgeschlossen. Der Strategie-Workshop (Modul 2) liefert nach 1–2 Wochen die Roadmap. Ein erster Pilot ist innerhalb von 4–6 Wochen live. Die volle Integration mit Skalierung läuft ab 3 Monaten. Jede Phase hat klare Go/No-Go-Entscheidungen – kein Folge-Investment ohne messbares Ergebnis.',
        },
        {
          question: 'Wie unterscheidet sich ENBET von klassischer KI-Beratung?',
          answer: 'Drei Punkte: (1) Retail-Expertise statt generischem KI-Wissen – echtes Verständnis für stationäre Abläufe, Filialstrukturen und die Realität an der Front. (2) Klare Priorisierung – wir sagen auch, was keinen Sinn macht. (3) Umsetzung zuerst – Roadmaps und Schulungen sind kein Selbstzweck, nur messbare Ergebnisse zählen (ROME-Prinzip).',
        },
        {
          question: 'Was ist das ROAD × ROME-Framework?',
          answer: 'ROAD steht für Requirements, Operationalize Data, Analytic Method, Deployment – das Strukturframework aus der angewandten Datenwissenschaft. ROME (Result Only Matters Environment) ist das übergeordnete Prinzip: Am Ende zählt nur ein messbares Ergebnis im Betrieb, kein Konzept und keine Folie ist Selbstzweck.',
        },
        {
          question: 'Bietet ENBET KI-Beratung auch für kleine Einzelhändler?',
          answer: 'Ja. Der KI Ready Check (850 € Festpreis) ist explizit so dimensioniert, dass auch KMU einen niederschwelligen Festpreis-Einstieg haben. Sinkende Einstiegsbarrieren, modulare Tools und operativer Pragmatismus machen KI gerade für kleine und mittlere Händler zugänglich.',
        },
      ],
    },
    cta: {
      title: 'Lassen Sie uns über Ihr Unternehmen sprechen',
      text: 'Wenn Sie KI sinnvoll einsetzen möchten, ohne die menschliche Stärke Ihres stationären Geschäfts zu verlieren, dann ist EnBet Consulting der richtige Ansprechpartner. Gemeinsam finden wir heraus, wo echte Entlastung möglich ist, wie Servicequalität spürbar steigt und welche nächsten Schritte wirklich zu Ihrem Betrieb passen.',
      button: 'Erstgespräch vereinbaren',
      name: 'Name',
      email: 'E-Mail',
      company: 'Unternehmen (optional)',
      message: 'Nachricht',
      send: 'Nachricht senden',
      success: 'Nachricht erfolgreich gesendet!',
      error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
    },
    cookie: {
      headline: 'Volle Kontrolle für Ihre Frontline.',
      text: 'Wir nutzen Daten nur dort, wo sie echten Mehrwert bieten – um die Performance dieser Seite so effizient wie Ihr Backoffice zu machen.',
      accept: 'Einverstanden & Optimieren',
      decline: 'Nur das Nötigste',
      privacy: 'Datenschutz',
    },
    blog: { label: 'Insights', title: 'Aktuelle Beiträge', readMore: 'Zum Beitrag' },
    footer: { rights: 'Alle Rechte vorbehalten.', privacy: 'Datenschutz', imprint: 'Impressum' },
  },
  en: {
    nav: { home: 'Home', services: 'Services', method: 'ROAD Framework', blog: 'Insights', contact: 'Request consultation' },
    hero: {
      badge: 'AI Consulting for brick-and-mortar retail, chains & franchise systems',
      title: 'AI in brick-and-mortar retail that actually works.',
      sub: 'ENBET stands for Entertain Better. Because that\'s what brick-and-mortar retail is about: real interaction between people, experiences no online shop can deliver. We help retail companies deploy AI so that your teams have more time for what matters — the customer.',
      text: '',
      cta1: 'Book a free potential analysis',
      cta2: 'View services',
    },
    intro: {
      title: 'AI in retail needs more than good tools.',
      paragraphs: [
        'There are plenty of concepts. Plenty of strategy decks. What\'s missing is someone who makes sure AI lands not on a screen but in daily operations — at the counter, in the stockroom, in customer conversations.',
        'ENBET (Entertain Better) Consulting doesn\'t deliver slides. We develop roadmaps that work with your team. The name says it all: it\'s about better entertain — not through more decks, but through more time for what makes humans in brick-and-mortar retail uniquely human.',
        'With the ROAD framework we analyse where your teams can be relieved today, where customer contact is suffering — and where your people can work more productively tomorrow without losing their humanity.',
      ],
    },
    why: {
      title: 'No off-the-shelf AI consulting.',
      paragraphs: [
        'ENBET (Entertain Better) combines deep understanding of brick-and-mortar operations with concrete AI know-how. That\'s what sets us apart from classic consulting.',
        'Retail expertise — No generic AI knowledge that fits everyone. Real understanding of in-store workflows, chain structures and the reality on the floor – where decisions about customer satisfaction and revenue are made every day.',
        'Clear prioritisation — We also tell you what doesn\'t make sense. Honest assessment protects you from misinvestments – and preserves your resources for what actually works.',
        'Implementation first — Roadmaps, trainings and audits are not ends in themselves. Everything is built so AI lands in actual operations – guided by the ROME principle: only measurable results count.',
      ],
    },
    audience: {
      title: 'Who ENBET (Entertain Better) is built for.',
      intro: 'We work with companies that consciously want to develop their human strength — not with those who deploy technology for technology\'s sake. Entertain Better means: people at the centre. AI as a tool that clears the way.',
      bullets: [
        { title: 'Brick-and-mortar stores with high customer proximity', text: 'Where personal contact is the most important competitive advantage.' },
        { title: 'Chain stores and service-intensive locations', text: 'Where standardisation and humanity must work at the same time.' },
        { title: 'Franchise systems and multi-location concepts', text: 'Where consistency across locations must be reconcilable with local identity.' },
        { title: 'Retail companies with frontline teams', text: 'Where employees are the first — and often only — interface to the customer.' },
        { title: 'Companies that understand customer proximity as a real competitive advantage', text: 'Online retail can\'t hug a customer. Brick-and-mortar can. That\'s what it\'s about.' },
      ],
      closing: 'If you\'re looking for a clear direction for better workflows, stronger teams and higher service quality — then you\'re in the right place.',
    },
    road: {
      label: 'ROAD Framework',
      title: 'How we structure AI adoption in brick-and-mortar retail',
      intro: '',
      steps: [],
    },
    services: {
      label: 'Services',
      title: 'AI in 3 clear steps — from diagnosis to production.',
      subtitle: 'Three stations. From an honest baseline check to AI productively running in operations. Each module can be booked separately — or as a coherent path.',
      cta_label: 'Book a call',
      items: [
        {
          title: 'AI Ready Check',
          price_label: 'Fixed price: € 850',
          subtitle: 'Comprehensive operational assessment & potential analysis',
          quote: 'Garbage in, garbage out.',
          quote_sub: 'Honest data. Clear decisions. No budget burned on AI experiments.',
          kpis: [
            { value: '5+', label: 'Departments analysed' },
            { value: '100%', label: 'Data clarity' },
          ],
          tagline: 'The unfiltered truth for your business.',
          text: 'The AI Ready Check is your well-founded, data-based diagnosis – no sugar-coating, no off-the-shelf template. Artificial intelligence must not be an expensive experiment. It has to deliver measurable economic value. Before you invest, we clarify whether and where it pays off.',
          bullets: [
            { label: 'Real data, not standard templates', text: 'An individual, in-depth analysis of your business — no automated boilerplate.' },
            { label: 'Structured process diagnostic', text: 'Crystal-clear identification of your operational friction, media breaks and daily bottlenecks.' },
            { label: 'Quantified time loss', text: 'We put a hard number on the daily lost time per department — real figures, real facts.' },
            { label: 'Objective economic assessment', text: 'An honest, vendor-neutral evaluation of which AI applications are actually profitable for you.' },
            { label: 'Maximum investment safety', text: 'Your shield against expensive wrong decisions and costly follow-up issues.' },
          ],
          duration: 'Individually prepared · location-independent via remote audit',
        },
        {
          title: 'AI Strategy Workshop',
          price_label: 'Investment: € 3,500',
          subtitle: 'Your AI strategy with rollout plan & use-case mapping',
          quote: 'Strategy is not a PowerPoint.',
          quote_sub: 'Strategy is a decision — with numbers, owners and a date.',
          kpis: [
            { value: '1–2 wks', label: 'preparation' },
            { value: '3 phases', label: 'clear roadmap' },
          ],
          tagline: 'From analysis to an actionable roadmap.',
          text: 'A report only matters if it is translated into a clear, practical strategy. In a joint strategy workshop we transform the insights from the Ready Check into a plan that works with your decision-makers — not against them.',
          bullets: [
            { label: 'Your AI strategy with rollout plan', text: 'The concrete, strategic foundation including a clear timeline.' },
            { label: 'Interactive use-case mapping', text: 'Joint prioritisation by economic leverage and feasibility.' },
            { label: 'Validated ROI calculation', text: 'Sound calculation of annual savings potential relative to implementation cost.' },
            { label: 'Pragmatic 3-phase roadmap', text: 'A chronological plan for internal adoption and execution.' },
            { label: 'Concrete quick wins', text: 'Immediately actionable improvements that deliver relief without long IT projects.' },
          ],
          duration: '1–2 weeks preparation · Interactive expert workshop with your decision-makers',
        },
        {
          title: 'AI Integration',
          price_label: 'Tailored quote',
          subtitle: 'Turnkey implementation, support & scaling',
          quote: 'The best strategy fails without execution.',
          quote_sub: 'We stay with you all the way into daily operations — not just to the slide deck.',
          kpis: [
            { value: '4–6 wks', label: 'first pilot live' },
            { value: 'Live', label: 'cost monitoring' },
          ],
          tagline: 'From concept to productive application in the real business.',
          text: 'The best strategy fails if the technical implementation stumbles or the team rejects the new tools. We stay with you all the way into daily operations — not just to the slide deck.',
          bullets: [
            { label: 'Agile pilot setup', text: 'Functional prototypes within 4–6 weeks for first measurable results.' },
            { label: 'Seamless system integration', text: 'Step-by-step rollout during live operations without disrupting daily business.' },
            { label: 'Live cost & quality monitoring', text: 'Continuous oversight to prevent exploding API or cloud bills.' },
            { label: 'Hands-on team training', text: 'Targeted enablement of your people for maximum adoption and confident AI use.' },
            { label: 'Future-proof scaling', text: 'Continuous optimisation and expansion for long-term digital growth.' },
          ],
          duration: 'Project duration from 3 months · scope tailored to your infrastructure',
        },
      ],
    },
    howWeWork: {
      title: 'How we work together.',
      paragraphs: [
        'We work with few companies at a time — deliberately. Not because we couldn\'t scale, but because quality and proximity are not marketing promises.',
        'Our formats are personal, structured, and always aimed at a concrete result. This includes personal conversations, on-site visits and joint learning formats in small groups.',
        'Companies benefit not only from our guidance — but also from each other. Good questions, real experiences and honest exchange often create more progress than isolated individual measures.',
        'Our goal: Create no dependencies — but make companies clearer, more effective and more independent.',
      ],
    },
    community: {
      title: 'Learning Does Not End With the Project',
      paragraphs: [
        'We believe in real connection. Not only between companies and customers, but also between people who bear responsibility and want to improve.',
        'That is why we create spaces for exchange, reflection, and collaborative learning. Small groups, personal encounters, and thinking together help develop quality in the long term.',
        'This way, a project becomes more than a conclusion. A network of practice, trust, and continuous development emerges.',
      ],
    },
    faq: {
      label: 'Frequently asked',
      title: 'Answers to the questions that matter.',
      subtitle: 'What companies most often want to know before working with us.',
      items: [
        {
          question: 'What does AI consulting at ENBET Consulting cost?',
          answer: 'Module 1 (AI Ready Check) is a fixed price of € 850. Module 2 (AI Strategy Workshop) is € 3,500. Module 3 (AI Integration) is project-based and quoted individually. The first 20-minute potential check with Sebastian Funke is always free — no sales pressure, no follow-up costs.',
        },
        {
          question: 'Where is ENBET Consulting based?',
          answer: 'ENBET Consulting (Entertain Better) is based in Schauenburg near Kassel in Northern Hesse, Germany, and works with companies throughout Germany. Audits are conducted remotely; workshops and integration on-site or hybrid.',
        },
        {
          question: 'What does Entertain Better mean?',
          answer: 'ENBET stands for Entertain Better. In brick-and-mortar retail, the greatest strength is not technology but real human interaction. AI should not replace employees but give them time back for advice, proximity, service and experience.',
        },
        {
          question: 'How long does AI adoption in brick-and-mortar retail take?',
          answer: 'The AI Ready Check (Module 1) is completed remotely within 1–2 weeks. The Strategy Workshop (Module 2) delivers the roadmap after another 1–2 weeks. A first pilot goes live within 4–6 weeks. Full integration with scaling starts from 3 months. Every phase has clear go/no-go decisions — no follow-up investment without measurable results.',
        },
        {
          question: 'How does ENBET differ from classic AI consulting?',
          answer: 'Three points: (1) Retail expertise instead of generic AI knowledge — real understanding of in-store workflows, chain structures and the reality on the floor. (2) Clear prioritisation — we also tell you what does not make sense. (3) Implementation first — roadmaps and trainings are not ends in themselves; only measurable results count (ROME principle).',
        },
        {
          question: 'What is the ROAD × ROME framework?',
          answer: 'ROAD stands for Requirements, Operationalize Data, Analytic Method, Deployment — the structural framework from applied data science. ROME (Result Only Matters Environment) is the overarching principle: in the end, only a measurable result in operations counts; no concept or slide is an end in itself.',
        },
        {
          question: 'Does ENBET also offer AI consulting for small retailers?',
          answer: 'Yes. The AI Ready Check (€ 850 fixed price) is explicitly dimensioned so that SMEs have a low-threshold fixed-price entry point. Lower entry barriers, modular tools and operational pragmatism make AI accessible especially for small and medium-sized retailers.',
        },
      ],
    },
    cta: {
      title: "Let's Talk About Your Business",
      text: 'If you want to deploy AI meaningfully without losing the human strength of your brick-and-mortar business, then EnBet Consulting is the right partner. Together we find out where real relief is possible, how service quality visibly increases, and which next steps truly fit your business.',
      button: 'Schedule a consultation',
      name: 'Name',
      email: 'Email',
      company: 'Company (optional)',
      message: 'Message',
      send: 'Send message',
      success: 'Message sent successfully!',
      error: 'Error sending message. Please try again.',
    },
    cookie: {
      headline: 'Full Control for Your Frontline.',
      text: 'We only use data where it delivers real value – to make this site as efficient as your back office.',
      accept: 'Agree & Optimize',
      decline: 'Essentials Only',
      privacy: 'Privacy',
    },
    blog: { label: 'Insights', title: 'Latest Posts', readMore: 'Read article' },
    footer: { rights: 'All rights reserved.', privacy: 'Privacy', imprint: 'Imprint' },
  },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('de');
  const t = useCallback((key) => {
    const keys = key.split('.');
    let result = translations[lang];
    for (const k of keys) { result = result?.[k]; }
    return result || key;
  }, [lang]);
  const toggleLang = useCallback(() => setLang(p => p === 'de' ? 'en' : 'de'), []);
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
